/**
 * DisciplineSection.jsx - one discipline in full: its zones, each zone's
 * phases and sign-offs.
 */
import { GREEN, GREY, INK, SUBLABEL } from './theme';
import { clampPct, pad2, signedCount } from './helpers';
import { Bar } from './Primitives';
import { PhaseList } from './PhaseList';
import { SignoffList } from './SignoffList';

export function ZoneBlock({ zone, first }) {
  const pct = clampPct(zone);
  const phases = zone.phases || [];
  const signoffs = zone.signoffs || [];
  return (
    <div className="svm-zone" style={{ marginTop: first ? 14 : 20 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          gap: 10,
          flexWrap: 'wrap',
        }}
      >
        <span
          style={{
            fontSize: 10.5,
            fontWeight: 800,
            letterSpacing: '1.6px',
            textTransform: 'uppercase',
            color: INK,
            minWidth: 0,
            overflowWrap: 'anywhere',
          }}
        >
          {zone.key}
        </span>
        <span
          style={{
            fontSize: 10.5,
            fontWeight: 700,
            letterSpacing: '0.8px',
            color: GREY,
            flexShrink: 0,
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {signedCount(zone)}/{zone.total || 0} SIGNED
          <span style={{ color: pct >= 100 ? GREEN : INK, fontWeight: 800, marginLeft: 9 }}>{pct}%</span>
        </span>
      </div>
      <div style={{ marginTop: 7 }}>
        <Bar pct={pct} height={5} />
      </div>

      {phases.length > 0 && <PhaseList phases={phases} />}
      {signoffs.length > 0 && <SignoffList signoffs={signoffs} />}
    </div>
  );
}

export function DisciplineSection({ discipline, index }) {
  const pct = clampPct(discipline);
  const zones = discipline.zones || [];
  return (
    <section style={{ marginTop: 26 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          gap: 12,
          flexWrap: 'wrap',
          paddingBottom: 6,
          borderBottom: '1px solid ' + GREEN,
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: 13,
            fontWeight: 800,
            color: INK,
            lineHeight: 1.35,
            letterSpacing: '1.3px',
            textTransform: 'uppercase',
            minWidth: 0,
            overflowWrap: 'anywhere',
          }}
        >
          <span style={{ color: GREEN, marginRight: 10, fontVariantNumeric: 'tabular-nums' }}>{pad2(index + 1)}</span>
          {discipline.label}
        </h2>
        <span
          style={{
            fontSize: 11,
            color: GREY,
            flexShrink: 0,
            letterSpacing: '0.3px',
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {signedCount(discipline)} of {discipline.total || 0} signed
          <span style={{ color: pct >= 100 ? GREEN : INK, fontWeight: 800, marginLeft: 10 }}>{pct}%</span>
        </span>
      </div>
      {zones.length > 0 && (
        <div style={{ ...SUBLABEL, marginTop: 8 }}>
          {zones.length} {zones.length === 1 ? 'zone' : 'zones'}
        </div>
      )}
      {zones.map((zone, i) => (
        <ZoneBlock key={zone.key || i} zone={zone} first={i === 0} />
      ))}
    </section>
  );
}

/* ------------------------------- notices + shell ------------------------------ */
